import type { CheckInResponseCreateInput } from '@/entities/check-in-response';
import { CheckInForm } from './CheckInForm';

interface CheckInSectionProps {
  hasInsights?: boolean;
  responses: CheckInResponseCreateInput;
  onResponseChange: (key: string, value: string) => void;
  onSubmit: () => void;
  isPending: boolean;
  error: Error | null;
}

export function CheckInSection({
  hasInsights,
  responses,
  onResponseChange,
  onSubmit,
  isPending,
  error,
}: CheckInSectionProps) {
  return (
    <div className="flex flex-1 flex-col">
      <h2 className="text-sm font-semibold">Morning Check-In</h2>
      <p className="mb-3 text-sm font-light text-gray-600">
        Take a minute to check in with yourself. We'll pull out what's important
        and add it to your plan.
      </p>
      <hr className="mb-4 border-gray-200" />
      <CheckInForm
        hasInsights={hasInsights}
        responses={responses}
        onResponseChange={onResponseChange}
        onSubmit={onSubmit}
        isPending={isPending}
        error={error}
      />
    </div>
  );
}
